/**
 * Device-local listing Save for visitors who are not signed in.
 *
 * The listing Save button used to open an email form and save nothing until
 * the visitor gave an address (Muse audit 2026-10-20: "lead capture, not
 * saving", FLEET_FORWARD W12). A signed-out Save now saves on this device at
 * once; email updates and Google sign-in are offered after, not required.
 *
 * Kept apart from the server save state on purpose: the post-login resume
 * (useResumePendingSave) must still write saved_listings for a home that was
 * only saved on the device.
 */
import { deviceKeyList } from '@/lib/device-key-list'

export const DEVICE_SAVED_STORAGE_KEY = 'rr_saved_listings_v1'
export const DEVICE_SAVED_MAX = 200

const saved = deviceKeyList(DEVICE_SAVED_STORAGE_KEY, DEVICE_SAVED_MAX)

export const isDeviceSavedListing = saved.has
export const addDeviceSavedListing = saved.add
export const removeDeviceSavedListing = saved.remove
